module.exports = __webpack_public_path__ + "img/General-Dataflow-diagram.5a53543d.svg";